import { useSite } from "@/context/SiteContext";

export const inputCls =
  "block w-full rounded-xl border border-forest/20 bg-white px-4 py-3.5 text-base text-ink placeholder:text-[#6B7A72] transition-[border-color,box-shadow] focus:border-forest focus:outline-none focus:ring-4 focus:ring-forest/10";

export const Field = ({ label, error, id, optional, children }) => {
  const { t } = useSite();
  return (
  <div>
    <label htmlFor={id} className="mb-1.5 block text-[15px] font-bold text-forest">
      {label} {optional && <span className="font-normal text-sage">{t("optional")}</span>}
    </label>
    {children}
    {error && <p data-testid={`${id}-error`} role="alert" className="mt-1.5 text-sm font-medium text-red-700">{error}</p>}
  </div>
  );
};

// Hidden from humans; bots that fill it are silently dropped by the API.
export const Honeypot = ({ value, onChange }) => (
  <div aria-hidden="true" className="absolute left-[-9999px] h-0 w-0 overflow-hidden">
    <label htmlFor="website">Website</label>
    <input id="website" name="website" tabIndex={-1} autoComplete="off" value={value} onChange={(e) => onChange(e.target.value)} />
  </div>
);

export const PhoneInput = ({ id, value, onChange, testId }) => {
  const { t } = useSite();
  return (
  <div className="flex">
    <span className="inline-flex items-center rounded-l-xl border border-r-0 border-forest/20 bg-sand px-3.5 text-base font-semibold text-forest">+91</span>
    <input id={id} data-testid={testId} type="tel" inputMode="numeric" autoComplete="tel-national" maxLength={14} placeholder={t("form_phone_ph")}
      value={value} onChange={(e) => onChange(e.target.value.replace(/[^\d\s+-]/g, ""))} className={`${inputCls} rounded-l-none`} />
  </div>
  );
};
